import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BATTLE_ROOMS_FIELDS = {
    CLAN: 'clan',
    PLACES: 'places',
    RATING: 'rating',
    SERVER: 'server',
    SQUAD: 'squad',
}

export const BATTLE_ROOMS_TITLE = (
    <FormattedMessage
        id='battle_rooms.new.title'
        defaultMessage='Сражения кланов'
    />
)

export const REFRESH_UNITS_LIST_TOOLTIP_TITLE = (
    <FormattedMessage
        id='battle_rooms.refresh_units_list_tooltip_title'
        defaultMessage='Обновить список'
    />
)

export const REFRESH_UNITS_LIST_TOOLTIP_BODY = (
    <FormattedMessage
        id='battle_rooms.refresh_units_list_tooltip_body'
        defaultMessage='Нажмите, чтобы обновить список отрядов.'
    />
)

export const BATTLE_ROOMS_UNITS_LIST = (
    <FormattedMessage
        id='battle_rooms.units_list'
        defaultMessage='Список отрядов'
    />
)

export const BATTLE_ROOMS_UNITS_LIST_BUTTON = (
    <FormattedMessage
        id='battle_rooms.units_list_button'
        defaultMessage='К списку отрядов'
    />
)

export const BATTLE_ROOMS_UNIT_DISABLED = (
    <FormattedMessage
        id='battle_rooms.unit_disabled'
        defaultMessage='Набор в состав отряда закрыт'
    />
)

export const BATTLE_MODE_DISABLED_ON_PERIPHERY = (
    <FormattedMessage
        id='battle_rooms.battle_mode_disabled_on_periphery'
        defaultMessage='Время начала станет известно позже'
    />
)

export const BATTLE_ROOMS_COLUMNS = {
    clan: (
        <FormattedMessage
            id='battle_rooms.columns.clan'
            defaultMessage='Подходящие отряды'
        />
    ),
    rating: (
        <FormattedMessage
            id='battle_rooms.columns.rating'
            defaultMessage='Рейтинг'
        />
    ),
    server: (
        <FormattedMessage
            id='battle_rooms.columns.server'
            defaultMessage='Сервер'
        />
    ),
    squad: (
        <FormattedMessage
            id='battle_rooms.columns.squad'
            defaultMessage='Состав'
        />
    ),
    legionaries: (
        <FormattedMessage
            id='battle_rooms.columns.legionaries'
            defaultMessage='Легионеры'
        />
    ),
    places: (
        <FormattedMessage
            id='battle_rooms.columns.places'
            defaultMessage='Места'
        />
    ),
    vehicles: (
        <FormattedMessage
            id='battle_rooms.columns.vehicles'
            defaultMessage='Техника'
        />
    ),
}

export const STATUS_BATTLE_READY_MESSAGE = (
    <FormattedMessage
        id='battle_rooms.squad.status_battle_ready_message'
        defaultMessage='Бой начнётся по готовности'
    />
)

export const STATUS_IN_BATTLE_MESSAGE = (
    <FormattedMessage
        id='battle_rooms.squad.status_in_battle_message'
        defaultMessage='Отряд в бою'
    />
)

export const STATUS_MATCHING_LEGIONARIES = (
    <FormattedMessage
        id='battle_rooms.squad.status_matching_legionaries'
        defaultMessage='Автонабор легионеров...'
    />
)

export const STATUS_BATTLE_SCHEDULE_MESSAGE = (time) => {
    return (
        <FormattedMessage
            id='battle_rooms.squad.status_battle_shedule_today_message'
            defaultMessage='Начало {time}'
            values={{ time }}
        />
    )
}

export const PLAYERS_COLUMN_DESCRIPTION = (
    <FormattedMessage
        id='battle_rooms.squad.tooltips.players.message'
        defaultMessage='Текущее и максимальное количество игроков в составе отряда.'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/constants.jsx